/**
 * Created by pawel on 21/10/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */


import {merge as observableMerge ,  Observable } from 'rxjs';

import {map, startWith} from 'rxjs/operators';
import { FormGroup } from "@angular/forms";

/**
 * This function coerces a string into a string literal type.
 * Using tagged union types in TypeScript 2.0, this enables
 * powerful typechecking of our reducers.
 *
 * Since every action type passes through this function it
 * is a good place to ensure all of our action labels
 * are unique.
 */

let typeCache: { [type: string]: boolean } = {};
export function type<T>(type: T | ''): T {
  if (typeCache[<string>type]) {
    throw new Error(`Action type "${type}" is not unqiue"`);
  }

  typeCache[<string>type] = true;

  return <T>type;
}

export function formChangesStream(form: FormGroup, formChangesOverwrite$: Observable<boolean>) {
    return observableMerge(
        form.valueChanges.pipe(
            map(() => true),
            startWith(false),),
        formChangesOverwrite$
    ).pipe(startWith(false));
}
